<!--The content below is only a placeholder and can be replaced.-->
<div id="dynamicElementContainer">
  <ng-template #dynamicElementInsertionPoint></ng-template>
</div>
<router-outlet (activate)="onRouterOutletActivated($event)"></router-outlet>
<app-toolbar *ngIf="!isLogin()"></app-toolbar>
